import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { LobbyState } from '@/store/modules/lobby/index';
import {
  CHANGE_PASSWORD_ERRORS,
  CHANGE_PASSWORD_LOADING,
  CHANGE_USER_DATA_CLEANSING_LOADING,
  HELP_DESK_DETAILS,
  LOBBY_SUCCESS_DIALOG,
  MUST_CHANGE_PASSWORD,
  MUST_PERFORM_DATA_CLEANSING,
  OPEN_POPUP_CHANGES_NOTIFICATION_FLAG,
  ORG_NEWS, PERFORM_CHANGE_PASSWORD,
  PERFORM_DATA_CLEANSING_ERRORS,
  USER_DATA_CLEANSING_ERRORS, USER_PERFORM_DATA_CLEANSING,
} from '@/types/lobby.types';
import { HelpDeskDetailsModel } from '@/models/lobby/helpDeskDetails.model';

export const getters: GetterTree<LobbyState, RootState> = {

  [ORG_NEWS](state): string[] {
    return state.orgNews;
  },

  [HELP_DESK_DETAILS](state): HelpDeskDetailsModel {
    return state.helpDeskDetails;
  },

  [CHANGE_PASSWORD_ERRORS](state) {
    return state.changePasswordErrors;
  },

  [USER_DATA_CLEANSING_ERRORS](state) {
    return state.userDataCleansingErrors;
  },

  [LOBBY_SUCCESS_DIALOG](state): boolean {
    return state.lobbySuccessDialog;
  },

  [MUST_CHANGE_PASSWORD](state): boolean {
    return state.mustChangePassword;
  },

  [MUST_PERFORM_DATA_CLEANSING](state): boolean {
    return state.mustPerformDataCleansing;
  },

  [USER_PERFORM_DATA_CLEANSING](state): boolean {
    return state.userPerformDataCleansing;
  },

  [PERFORM_CHANGE_PASSWORD](state): boolean {
    return state.performChangePassword;
  },

  [PERFORM_DATA_CLEANSING_ERRORS](state): string[] {
    return state.performDataCleansingErrors;
  },

  [CHANGE_PASSWORD_LOADING](state): boolean {
    return state.changePasswordLoading;
  },

  [CHANGE_USER_DATA_CLEANSING_LOADING](state): boolean {
    return state.changeUserDataCleansingLoading;
  },

  [OPEN_POPUP_CHANGES_NOTIFICATION_FLAG](state): boolean {
    return state.openPopupChangesNotificationFlag;
  },

};
